import { AxiosRequestConfig } from "axios";
import client from "libs/HttpClient";

/**
 * Represents the structure of a request for listing product types.
 */
interface ListModuleRequest {
  queryKey: [number, string, string, string];
}

/**
 * Service class for handling Module.
 */
class ModuleService {
  static listModule(request: ListModuleRequest) {
    const page_no = request.queryKey[0];
    const searchText = request.queryKey[1];
    const status = request.queryKey[2];
    const product_id = request.queryKey[3];

    return client.get(
      `admin/module/list?page=${page_no}&search_text=${searchText}&status=${status}&product_id=${product_id}`,
      request as AxiosRequestConfig
    );
  }

  /**
   * Adds a new module based on the provided request.
   *
   * @param request - The request parameters for adding a Module.
   * @returns A Promise that resolves to the Axios response for the add Module request.
   */
  static addModule(request: any) {
    return client.post("admin/module/add", request);
  }

  /**
   * Updates the status of a Module based on the provided request.
   *
   * @param request - The request parameters for updating the status of a Module.
   * @returns A Promise that resolves to the Axios response for the update status request.
   */
  static updateStatusModule(request: any) {
    return client.patch("admin/module/update-status", request);
  }

  /**
   * Updates the details of a Module based on the provided request.
   *
   * @param request - The request parameters for updating a Module.
   * @returns A Promise that resolves to the Axios response for the update Module request.
   */
  static updateModule(request: any) {
    return client.post("admin/module/edit", request);
  }

  /**
   * Retrieves the details of a Module based on the provided parameters.
   *
   * @param params - The parameters for retrieving the Module details.
   * @returns A Promise that resolves to the Axios response containing the Module details.
   */
  static viewModule(params: any) {
    return client.get("admin/module/get", { params });
  }

  /**
   * Deletes a Module based on the provided parameters.
   *
   * @param params - The parameters for deleting the Module.
   * @returns A Promise that resolves to the Axios response for the delete Module request.
   */
  static deleteModule(params: any) {
    return client.delete("/admin/module/delete", { params });
  }

  /**
   * get Module Details based on the provided request.
   *
   * @param request - The request parameters for getting a Module.
   * @returns A Promise that resolves to the Axios response for the update Module request.
   */
  static getModuleList(request: any) {
    return client.get("admin/module/get-module-list", request);
  }
}

export { ModuleService };
